export default __webpack_public_path__ + "static/media/pinkspacedestlocked_trans.89b6a461.png";